import React, { useContext, useState, Fragment } from 'react';
import context from '../context';
import styled from 'styled-components';
import HamburgerMenu from 'react-hamburger-menu';
import { Container } from 'react-bootstrap';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { FacebookOutlined, InstagramOutlined, TwitterOutlined } from '@ant-design/icons';

import Logo from './logo-mobil';
import RateBar from './ratebar';
import { NavLink } from '../styled-components';

const Header = styled.header`
  background-color: ${props => props.theme.primaryColor};
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0.5rem 0 1.9rem;
  z-index: 1000;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const NavPanel = styled.div`
  background-color: ${props => props.theme.primaryColor};
  height: calc(100vh - 81.38px);
  width: 100vw;
  transition: 500ms ease;
  position: fixed;
  left: ${props => (props.visible ? '0' : '100vw')};
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: ${props => (props.horizontal ? 'flex' : 'block')};
  text-align: center;
`;

const NavItem = styled.li`
  font-size: 1.6rem;
  margin: 1rem 0;
  position: relative;
`;

const AccentButton = styled(NavLink)`
  background-color: #F9A200;
  color: #fff !important;
  padding: 0.6rem 1.5rem;
  border-radius: 999px;
  font-weight: bold;
  transition: background-color 0.3s ease;
  &:hover { background-color: #e08f00; }
`;

/* Submenú */
const SubmenuToggle = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  color: #fff;
  font: inherit;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: .5rem;

  &:hover { opacity: .95; }
`;

const Submenu = styled.ul`
  list-style: none;
  margin: .35rem 0 0;
  padding: .5rem 0;
  background: #fff;
  color: #111;
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(0,0,0,.2);
  width: 86vw;
  max-width: 420px;
  transition: max-height .25s ease, opacity .25s ease;
  max-height: ${p => (p.open ? '240px' : '0')};
  opacity: ${p => (p.open ? 1 : 0)};
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
`;

const SubmenuItem = styled.li`
  font-size: 1.2rem;
`;

const SubmenuLink = styled(AniLink)`
  display: block;
  padding: 12px 16px;
  color: #111 !important;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: .2px;

  &:hover {
    background: rgba(0,0,0,.06);
    color: ${p => p.theme.primaryColor} !important;
  }
`;

export default () => {
  const [open, setOpen] = useState(false);
  const [subOpen, setSubOpen] = useState(false);
  const state = useContext(context);

  // Base query para /properties
  const baseQuery =
    '?email=propiedadeslasflores%40gmail.com' +
    '&status=PUBLICADA%2CARRENDADA%2CVENDIDA' +
    '&limit=12' +
    '&typeId=office' +
    '&id=5e8e36b31c9d440000d35090' +
    '&propertyType=' +
    '&commune=' +
    '&stringSearch=' +
    '&priceMin=' +
    '&priceMax=' +
    '&totalAreaFrom=' +
    '&totalAreaTo=' +
    '&bedrooms=' +
    '&bathrooms=' +
    '&currency=CLP';

  const ventaHref = `/properties/${baseQuery}&operation=VENTA`;
  const arriendoHref = `/properties/${baseQuery}&operation=ARRIENDO`;

  const closeAll = () => {
    setOpen(false);
    setSubOpen(false);
  };

  return (
    <Fragment>
      <Header className="d-lg-none">
        <Container>
          <Navigation>
            <AniLink paintDrip hex={state.primaryColor} to="/" duration={.5}>
              <Logo mobile />
            </AniLink>
            <HamburgerMenu
              isOpen={open}
              menuClicked={() => {
                const next = !open;
                setOpen(next);
                if (!next) setSubOpen(false);
              }}
              width={24}
              height={15}
              strokeWidth={2}
              rotate={0}
              color="#ffffff"
              borderRadius={0}
              animationDuration={0.5}
            />
          </Navigation>
        </Container>
      </Header>

      <NavPanel visible={open}>
        <RateBar />

        <NavList>
          {/* Publica tu propiedad */}
          <NavItem>
            <AniLink paintDrip hex={state.primaryColor} to="/publica" onClick={closeAll} duration={.5}>
              <AccentButton light>Publica tu propiedad</AccentButton>
            </AniLink>
          </NavItem>

          {/* Las Flores Inmobiliarias */}
          <NavItem>
            <AniLink paintDrip hex={state.primaryColor} to="/in-construction" onClick={closeAll} duration={.5}>
              <NavLink light>Las Flores Inmobiliarias</NavLink>
            </AniLink>
          </NavItem>

          {/* Propiedades con submenú */}
          <NavItem>
            <SubmenuToggle onClick={() => setSubOpen(v => !v)}>
              <NavLink light>Propiedades</NavLink>
            </SubmenuToggle>
            <Submenu open={subOpen}>
              <SubmenuItem>
                <SubmenuLink paintDrip hex={state.primaryColor} to={ventaHref} duration={.4} onClick={closeAll}>
                  Venta
                </SubmenuLink>
              </SubmenuItem>
              <SubmenuItem>
                <SubmenuLink paintDrip hex={state.primaryColor} to={arriendoHref} duration={.4} onClick={closeAll}>
                  Arriendo
                </SubmenuLink>
              </SubmenuItem>
            </Submenu>
          </NavItem>

          {/* Nosotros */}
          <NavItem>
            <AniLink paintDrip hex={state.primaryColor} to="/about" onClick={closeAll} duration={.5}>
              <NavLink light>Nosotros</NavLink>
            </AniLink>
          </NavItem>

          {/* Contacto */}
          <NavItem>
            <AniLink paintDrip hex={state.primaryColor} to="/contact" onClick={closeAll} duration={.5}>
              <NavLink light>Contacto</NavLink>
            </AniLink>
          </NavItem>
        </NavList>

        <NavList horizontal>
          <NavItem>
            <AniLink href={state.facebook} target="_blank" rel="noopener" onClick={closeAll}>
              <NavLink light><FacebookOutlined /></NavLink>
            </AniLink>
          </NavItem>
          <NavItem>
            <AniLink href={state.instagram} target="_blank" rel="noopener" onClick={closeAll}>
              <NavLink light><InstagramOutlined style={{ margin: '0 1rem' }} /></NavLink>
            </AniLink>
          </NavItem>
          <NavItem>
            <AniLink href={state.twitter} target="_blank" rel="noopener" onClick={closeAll}>
              <NavLink light><TwitterOutlined /></NavLink>
            </AniLink>
          </NavItem>
        </NavList>
      </NavPanel>
    </Fragment>
  );
};